const riot = require('riot');

riot.tag2('module-graph', '<div class="f ft s-full overflow-hidden s-flex-column-reverse"> <div class="h-full overflow-y-scroll py24" if="{graphLabels?.length}"> <div class="mb10 flex-fixed" each="{label, index in graphLabels}"> <div class="f fm"> <div class="w20 h8 mr5" riot-style="background-color: {label.color};"></div> <div class="text-label_high bold line-clamp-1">{label.label}</div> </div> <div class="text-label_high">{label.hour}</div> </div> <div class="fs13 py8">※ カラーはプロジェクトの最も回数の多いカラーを使用しています。</div> </div> <div class="graph s-full p24 mxa s-mb16" ref="chartContainer"></div> </div>', 'module-graph .graph,[data-is="module-graph"] .graph{max-width:500px;max-height:500px} module-graph .graph svg,[data-is="module-graph"] .graph svg{width:100%;height:100%}', '', function(opts) {

    this.generateGraphLabels = (sections, color, totalHours) => {

      let copied_sections = sections.slice();

      return copied_sections.sort((a, b) => b.hours - a.hours).map(d => ({
        color: color(d.items),
        label: `${d.label}`,
        hour: `${d.hours}h (${(d.hours / totalHours * 100).toFixed(2)}%)`,
        heightPercent: (d.hours / totalHours * 100)
      }));
    };

    this.deleteGraph = () => {
      d3.select(this.refs.chartContainer).selectAll('*').remove();
    };

    this.getMostFrequentColor = (items) => {
      const color_counts = items.reduce((acc, item) => {
        const color = item.relation.project?.data.color || '#cccccc';
        acc[color] = (acc[color] || 0) + 1;
        return acc;
      }, {});

      return Object.keys(color_counts).reduce((a, b) => color_counts[a] > color_counts[b] ? a : b);
    };

    this.renderChart = () => {
      const sections = this.opts.sections;
      const container = this.refs.chartContainer;
      const GRAPH_SIZE = 500;
      const width = GRAPH_SIZE;
      const height = GRAPH_SIZE;
      const radius = Math.min(width, height) / 2;

      this.deleteGraph();

      const svg = d3.select(container)
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .attr('viewBox', `0 0 ${width} ${height}`)
        .append('g')
        .attr('transform', `translate(${width / 2}, ${height / 2})`);

      const color = (items) => this.getMostFrequentColor(items);

      const pie = d3.pie()
        .value(d => d.hours)
        .sort(null);

      const arc = d3.arc()
        .innerRadius(0)
        .outerRadius(radius);

      const arc_tween = (d) => {
        const i = d3.interpolate({ startAngle: 0, endAngle: 0 }, d);
        return (t) => arc(i(t));
      };

      svg.selectAll('path')
        .data(pie(sections))
        .enter()
        .append('path')
        .attr('fill', d => color(d.data.items) + '')
        .attr('stroke', 'white')
        .attr('stroke-width', '1.5px')
        .transition()
        .duration(512)
        .attrTween('d', arc_tween);

      const total_hours = sections.reduce((sum, section) => sum + section.hours, 0);

      const LABEL_THRESHOLD = 10;
      svg.selectAll('text')
        .data(pie(sections))
        .enter()
        .append('text')
        .filter(d => (d.data.hours / total_hours * 100) >= LABEL_THRESHOLD)
        .each(function(d) {
          const centroid = arc.centroid(d);
          const mid_angle = d.startAngle + (d.endAngle - d.startAngle) / 2;
          const x = centroid[0] + Math.cos(mid_angle) * radius * 0.01;
          const y = centroid[1] + Math.sin(mid_angle) * radius * 0.1;

          const text_element = d3.select(this)
            .attr('transform', `translate(${x}, ${y})`)
            .style('text-anchor', 'middle')
            .style('font-size', '16px')
            .style('font-weight', '500')
            .style('text-shadow', '1px 1px 1px rgba(0,0,0,0.5)')
            .attr('fill', 'white')
            .html(null);

          const label_lines = d.data.label.split(' ');
          text_element.append('tspan')
            .attr('x', 0)
            .attr('dy', 0)
            .text(label_lines[0])
            .style('display', 'block')
            .style('max-width', '48px')
            .style('word-wrap', 'break-word');

          text_element.append('tspan')
            .attr('x', 0)
            .attr('dy', '1.2em')
            .text(`${d.data.hours}h (${(d.data.hours / total_hours * 100).toFixed(2)}%)`)
            .style('display', 'block')
            .style('max-width', '48px')
            .style('word-wrap', 'break-word');
        });

      this.graphLabels = this.generateGraphLabels(sections, color, total_hours);
      this.update();
    };
});